<template>
  <app-chip class="bg-deco-100 text-deco-950" icon="ph:monitor" :size="size">
    {{ $t("course.type.online_label") }}
  </app-chip>
</template>

<script lang="ts" setup>
defineProps<{
  size?: "small";
}>();
</script>
